import { Component, EventEmitter, inject, Output } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { CoreIconButton } from "@svs/angular";
import { ChatStore } from "../../@core/state/chat.store";

@Component({
  selector: "app-chat-input",
  imports: [
    CoreIconButton,
    FormsModule,
  ],
  templateUrl: "./chat-input.component.html",
  styleUrl: "./chat-input.component.scss",
})
export class ChatInputComponent {
  readonly chatStore = inject(ChatStore);
  @Output() submitted = new EventEmitter<string>();

  value: string;

  get streaming(): boolean {
    return this.chatStore.status() === 'streaming';
  }

  submit() {
    if(!this.value) return;
    this.submitted.emit(this.value);
    this.value = "";
  }

  stop() {
    this.chatStore.stop();
  }
}
